import { Button } from '@synoptic/ui-kit/button/button.js';
import { Input } from '@synoptic/ui-kit/input/input.js';
import { PropsWithChildren } from 'react';
import { useForm } from 'react-hook-form';
import { AiFilter, SaveFilterFormValues } from '../types';
import {
  modalFooterWithMargin,
  formFieldDescription,
} from './manage-filter.css';

interface SaveFilterFormProps {
  name?: AiFilter['name'];
  onCancel: () => void;
  onSubmit: (data: SaveFilterFormValues) => void;
}

export const SaveFilterForm = ({
  name,
  onCancel,
  onSubmit,
}: PropsWithChildren<SaveFilterFormProps>) => {
  const { register, handleSubmit, formState } = useForm<SaveFilterFormValues>({
    defaultValues: {
      name: name ?? '',
    },
    mode: 'onBlur',
  });
  return (
    <form
      onSubmit={async (e) => {
        e.stopPropagation();
        await handleSubmit(onSubmit)(e);
      }}
    >
      <Input
        label="Name your filter"
        placeholder="Enter filter name"
        errorMessage={formState.errors.name?.message}
        {...register('name', {
          required: {
            value: true,
            message: 'Name is required',
          },
          maxLength: {
            value: 30,
            message: 'Name must be less than 30 characters',
          },
          validate: (v) => v.trim().length > 0,
        })}
      />
      {!formState.errors.name && (
        <p className={formFieldDescription}>
          Name is based on the list name. You can change it.
        </p>
      )}
      <div className={modalFooterWithMargin}>
        <Button onClick={onCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          loading={formState.isSubmitting}
          disabled={!formState.isValid}
          type="submit"
          variant="primary"
        >
          Save
        </Button>
      </div>
    </form>
  );
};
